// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { WidgetBarOutput, WidgetIntervalType, FilterInput, ObjectTypeV1 } from 'thehive-sdk';
import { useDashboard } from '@Hooks/useDashboard';
import WidgetDrawer from '@Organisms/Dashboard/WidgetManage/WidgetDrawer';
import { getNewBarWidget } from './NewBarDrawer';
import { Form } from 'antd';
import { Store } from 'antd/lib/form/interface';
import { BarForm } from './BarForm';

interface BarDrawerProps {
    data: WidgetBarOutput;
}

export interface BarValues extends Store {
    title: string;
    interval: WidgetIntervalType;
    entity: ObjectTypeV1;
    dateField: string;
    category: string;
    stacked: boolean;
    filters: FilterInput[];
    periodDateField?: string;
}

const BarDrawer = ({ data }: BarDrawerProps): ReactElement => {
    const [form] = Form.useForm();
    const { editWidget } = useDashboard();

    const onFinish = (bar: BarValues): void => {
        const widgetId = data.id;
        const widgetBar: WidgetBarOutput = {
            ...getNewBarWidget(bar),
            id: widgetId,
        };

        editWidget(widgetBar, widgetId);
        form.resetFields();
    };

    return (
        <WidgetDrawer form={form} widgetType="bar">
            {(toggleDrawer, { setFieldsTouched }) => (
                <BarForm
                    onCancel={() => {
                        form.resetFields();
                        setFieldsTouched(false);
                        toggleDrawer();
                    }}
                    onChange={() => {
                        setFieldsTouched(true);
                    }}
                    form={form}
                    onFinish={(values) => {
                        onFinish(values);
                        toggleDrawer();
                    }}
                    defaultValues={data}
                />
            )}
        </WidgetDrawer>
    );
};

export default BarDrawer;
